import { CompanySettingsPermissions } from '../../modules/companySettings/permissions'
import { RoleName } from '../../types'
import { PermissionAction } from './permissionActionEnum'
import { RoleList } from './roleList'

export interface CompanySettingsPermissionsInfo {
  [CompanySettingsPermissions: string]: boolean
}

type Permission = {
  action: PermissionAction
  item: string
}

export type Role = {
  name: string
  permissions: Array<Permission>
}

// Note: works for now but might be to simple imagine stacked roles of BU-Manager, Network Manager etc. As a BU manager you could have targets, as a Networkmanager you will have targets but outside of Meply.
export const hasPermission = (item: string, userRoles: RoleName[]): boolean => {
  const permissionMatched: Permission[] = userRoles
    .flatMap((userRole: RoleName) => RoleList.filter((role) => role.name === userRole))
    .flatMap((permissions: Role) => permissions.permissions)
    .filter((permission: Permission) => permission.item === item)

  const isHideActionPresent = permissionMatched.some((x) => x.action === PermissionAction.Hide)

  const isViewAlwaysActionPresent = permissionMatched.some((x) => x.action === PermissionAction.ViewAlways)

  // If the user has at least one role for which the action is PermissionAction.Hide, the view will not be visible
  return permissionMatched.length !== 0 && (!isHideActionPresent || isViewAlwaysActionPresent)
}

export const getCompanySettingsPermissionInfo = (userRoles: RoleName[]): CompanySettingsPermissionsInfo => {
  const availableTabs = [
    CompanySettingsPermissions.appraisalsTab,
    CompanySettingsPermissions.reviewerTab,
    CompanySettingsPermissions.employeesTab,
    CompanySettingsPermissions.rankingTab,
    CompanySettingsPermissions.cultivatingTalentsTab,
    CompanySettingsPermissions.pyramidsTab,
    CompanySettingsPermissions.companyMeetingRequests,
    CompanySettingsPermissions.targetTemplatesTab,
    CompanySettingsPermissions.targetReportsTab,
    CompanySettingsPermissions.appraisalSeasonTab,
    CompanySettingsPermissions.hrFeedbackTab,
    CompanySettingsPermissions.hrBusinessPartnersTab,
    CompanySettingsPermissions.hrCountrySettingsTab,
    CompanySettingsPermissions.hrNationalContractReferenceTab,
  ]

  const permissionInfo: CompanySettingsPermissionsInfo = {}

  for (const tab of availableTabs) {
    permissionInfo[tab] = hasPermission(tab, userRoles)
  }

  return permissionInfo
}
